const getDomainPurchaseData = (rootState) => rootState.domainPurchase || null;

export default getDomainPurchaseData;
